
export const TYPE_FLEXIBLE_DATE_WITH_DRIVER = 1
export const TYPE_FIXED_DATE_WITH_DRIVER = 2
export const TYPE_FIXED_DATE_WITH_LOADERS = 3

export const INSTANT_PRICES_TYPE_NAMES = {
    [TYPE_FLEXIBLE_DATE_WITH_DRIVER]: 'flexible_date_with_driver',
    [TYPE_FIXED_DATE_WITH_DRIVER]: 'fixed_date_with_driver',
    [TYPE_FIXED_DATE_WITH_LOADERS]: 'fixed_date_with_loaders',
}



// WEBPACK FOOTER //
// ./client/constants/Instantprices.js